import { c as _c } from "react/compiler-runtime";
import { CenterAligned, classNames, FlexCenter, SpaceBetween, UnstyledButton } from "@opensea/ui-kit";
import { Close } from "@opensea/ui-kit/icons";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { StepIndicator } from "./StepIndicator";
export function MultiStepHeader(props) {
  const $ = _c(32);
  const {
    steps,
    currentStep,
    onStepClick,
    hidden: evaluateHidden,
    indicatorHidden,
    left,
    onClose,
    className
  } = props;
  const [playSelect] = usePlaySound(Sound.Select);
  let T0;
  let T1;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== currentStep || $[2] !== evaluateHidden || $[3] !== indicatorHidden || $[4] !== left || $[5] !== onStepClick || $[6] !== playSelect || $[7] !== steps) {
    const hidden = !currentStep || evaluateHidden?.(currentStep) || indicatorHidden?.(currentStep);
    const hiddenClassNames = classNames("transition duration-500 ease-out-quint", hidden && "-translate-y-1 opacity-0");
    T1 = SpaceBetween;
    t1 = classNames("z-10 px-3 py-4", hidden && "pointer-events-none", className);
    t2 = <CenterAligned className={classNames("size-[30px]", hiddenClassNames)}>{left}</CenterAligned>;
    const t4 = classNames("gap-1.5 md:gap-2", hiddenClassNames);
    let t5;
    if ($[14] !== currentStep || $[15] !== indicatorHidden || $[16] !== onStepClick || $[17] !== playSelect || $[18] !== steps) {
      t5 = steps.map((step, index) => <StepIndicator completed={currentStep ? steps.indexOf(currentStep) > index : true} hidden={indicatorHidden?.(step)} key={step} onClick={() => {
        onStepClick?.(step);
        playSelect();
      }} selected={step === currentStep} />);
      $[14] = currentStep;
      $[15] = indicatorHidden;
      $[16] = onStepClick;
      $[17] = playSelect;
      $[18] = steps;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t3 = <FlexCenter className={t4}>{t5}</FlexCenter>;
    T0 = CenterAligned;
    t0 = classNames("size-[30px]", hiddenClassNames);
    $[0] = className;
    $[1] = currentStep;
    $[2] = evaluateHidden;
    $[3] = indicatorHidden;
    $[4] = left;
    $[5] = onStepClick;
    $[6] = playSelect;
    $[7] = steps;
    $[8] = T0;
    $[9] = T1;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    T0 = $[8];
    T1 = $[9];
    t0 = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
  }
  let t4;
  if ($[20] !== onClose) {
    t4 = onClose ? <UnstyledButton onClick={onClose}><Close fill="text-primary" /></UnstyledButton> : null;
    $[20] = onClose;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== T0 || $[23] !== t0 || $[24] !== t4) {
    t5 = <T0 className={t0}>{t4}</T0>;
    $[22] = T0;
    $[23] = t0;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== T1 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3 || $[30] !== t5) {
    t6 = <T1 className={t1}>{t2}{t3}{t5}</T1>;
    $[26] = T1;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}